import React, { useState, useEffect, useRef, ReactNode } from 'react';
import Navbar from '../Navbar'; // Ensure the path to your Navbar is correct
import "./index.css";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [navHeight, setNavHeight] = useState<number>(0);
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const currentNav = navRef.current;
    if (!currentNav) return;

    // ResizeObserver tracks height changes from your CSS aspect-ratio automatically
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // borderBoxSize is the most accurate for elements with padding/borders
        const observedHeight = entry.borderBoxSize?.[0]?.blockSize 
          ?? entry.target.getBoundingClientRect().height;
        
        setNavHeight(observedHeight);
      }
    });

    resizeObserver.observe(currentNav);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <>
      {/* The ref is passed here. 
        Note: Your Navbar component MUST use React.forwardRef to receive this. 
      */}
      <Navbar ref={navRef} />

      <main 
        className='main' 
        style={{ marginTop: `${navHeight}px` }}
      >
        {children}
      </main>
    </>
  );
};

export default Layout;